import repository from './repository';
import axios from 'axios';

const API = process.env.VUE_APP_API_URL;

let SubscriberRepository = repository('/subscribers');

SubscriberRepository.getIndexData = () => {
    return axios.get(API + '/subscribers/index_data');
};

SubscriberRepository.getSubscriberHistory = (id) => {
    return axios.get(API + '/subscribers/history/' + id);
};

SubscriberRepository.setBlocks = (id, blocks) => {
    return axios.post(API + '/subscribers/set_blocks', {subscriber_id: id, blocks: {'blocks': blocks}});
};

SubscriberRepository.getBlocks = (id) => {
    return axios.post(API + '/subscribers/get_blocks', {subscriber_id: id});
};

SubscriberRepository.getSubscriptionData = (id) => {
    return axios.post(API + '/subscribers/get_data', {subscriber_id: id});
};

SubscriberRepository.makeCopy = (id, eventName) => {
    return axios.post(API + '/subscribers/make_copy', {subscriber_id: id, eventName: eventName});
};

SubscriberRepository.blankSubscriber = () => {
    return {
        name: '',
        active: true,
        event_name: '',
        priority: 0,
        queueCategory: null
    }
};

SubscriberRepository.validate = {
    name(n) {
        return (n.length >= process.env.VUE_APP_VALIDATION_SUBSCRIBER_MIN_NAME_LENGTH && n.length <= 255);
    },
    event(e) {
        return e.length > 1;
    },
    priority(p) {
        p = +p;
        return p >= 0 && p <= 10;
    }
};

export default SubscriberRepository;
